import React, { ReactElement } from 'react';
import styled, { ColorsTypes } from 'styled-components';

import { Box, Flex } from 'components/flex';
import { createMarkup } from 'app/utils';
import { Spinner } from 'components';

interface LoadingProps {
  label?: string;
  color?: ColorsTypes;
  bg?: ColorsTypes;
  alpha?: boolean | number;
  fixed?: boolean;
  bordered?: boolean;
}

interface WrapperProps {
  wrapperAlpha: boolean | number;
  wrapperBg: ColorsTypes;
}

interface LabelProps {
  textColor: ColorsTypes;
}

const Wrapper = styled(Flex)<WrapperProps>`
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  min-height: 50px;
  z-index: 1000;

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    background: ${({ theme, wrapperBg }) => theme.colors[wrapperBg]};
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    opacity: ${({ wrapperAlpha }) => `${wrapperAlpha}`};
  }
`;

const Label = styled(Box)<LabelProps>`
  margin-top: 10px;
  text-align: center;
  color: ${({ theme, textColor }) => theme.colors[textColor]};
  text-shadow: 0px 0px 3px ${({ theme }) => theme.colors.black};
`;

const Loading = ({ label, bg, color, alpha, fixed = true, bordered = false }: LoadingProps): ReactElement => {
  const wrapperBg = bg || 'dark_350';
  const textColor = color || 'white';
  const wrapperAlpha = alpha ? (typeof alpha === 'boolean' ? 0.5 : alpha) : alpha === 0 ? 0 : 1;

  return (
    <Wrapper
      borderRadius={bordered ? 4 : 0}
      position={fixed ? 'fixed' : 'absolute'}
      alignItems="center"
      justifyContent="center"
      wrapperBg={wrapperBg}
      wrapperAlpha={wrapperAlpha}
    >
      <Flex flexGrow={0} flexDirection="column" zIndex={150}>
        <Spinner />

        {Boolean(label) && (
          <Label textColor={textColor}>
            <div dangerouslySetInnerHTML={createMarkup(label)} />
          </Label>
        )}
      </Flex>
    </Wrapper>
  );
};

export default Loading;
